//@ts-ignore
import VideoThumbnail from "react-video-thumbnail";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo, useState } from "react";
import { useStyles } from "./styles";
import Box from "@mui/material/Box";
import { PlayCircleOutlineRounded } from "@mui/icons-material";

type ArtVideoProps = {
  name: string;
  video: string;
  onClick?: () => void;
};

export function ArtVideo({ onClick, name, video }: ArtVideoProps) {
  const styles = useStyles();
  const [thumbnail, setThumbnail] = useState<string>("");

  const altVideo = useMemo(() => {
    return `video-${name}`;
  }, [name]);

  const handleThumbnail = useCallback((data: string) => {
    setThumbnail(data);
  }, []);

  return (
    <>
      <Stack onClick={onClick} spacing={1} sx={{ cursor: "pointer" }}>
        <div className={styles.root}>
          <div className={styles.contentBtnVideo}>
            <PlayCircleOutlineRounded fontSize="large" />
          </div>
          <img
            id={altVideo}
            className={styles.image}
            src={thumbnail}
            alt={altVideo}
          />
        </div>
        <Typography variant="caption">{name}</Typography>
      </Stack>
      <Box display="none">
        <VideoThumbnail
          videoUrl={video}
          thumbnailHandler={handleThumbnail}
          renderThumbnail={false}
        />
      </Box>
    </>
  );
}
